import React from 'react';
import Timelines from '../../../../../shared/components/timeline/Timeline';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import moment from 'moment';

const ReconciliationDetailTimeLine = (): any => {
  const {reconciliationAuditTrail} = useSelector((state: RootState): any => state?.reconciliation);
  const timelineList = reconciliationAuditTrail?.map((item: any): any => {
    return {
      title: item.reconciliationStatus,
      remarks: item.reconciliationComments,
      date: moment(item.modifiedDate),
      attachments: [],
    };
  });
  return <>
    <Timelines
      timelineList={timelineList}
      type="reconciliation"
    />
  </>;
};

export default ReconciliationDetailTimeLine;
